import { render, staticRenderFns } from "./non_fiction.vue?vue&type=template&id=5dce3372&"
import script from "./non_fiction.vue?vue&type=script&lang=js&"
export * from "./non_fiction.vue?vue&type=script&lang=js&"
import style0 from "./non_fiction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports